// src/slices/ticketType/thunk.ts
// Async thunks cho Quản lý Loại Vé

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTicketTypes,
  getActiveTicketTypes,
  createTicketType as createTicketTypeAPI,
  updateTicketType as updateTicketTypeAPI,
  lockTicketType as lockTicketTypeAPI,
  unlockTicketType as unlockTicketTypeAPI,
  deleteTicketType as deleteTicketTypeAPI,
} from 'helpers/fakebackend_helper';
import { CreateTicketTypeDto, UpdateTicketTypeDto } from 'pages/TicketTypeManagement/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_type_messages');

interface GetTicketTypesParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  isLocked?: boolean;
}

const cleanParams = (params: any): any => {
  const cleaned: any = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const fetchTicketTypes = createAsyncThunk(
  'TicketType/fetchTicketTypes',
  async (params: GetTicketTypesParams = {}, { rejectWithValue }) => {
    try {
      const response = await getTicketTypes(cleanParams(params));
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tai_message'));
    }
  }
);

export const fetchActiveTicketTypes = createAsyncThunk(
  'TicketType/fetchActiveTicketTypes',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getActiveTicketTypes();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tai_message_2'));
    }
  }
);

export const createTicketType = createAsyncThunk(
  'TicketType/create',
  async (data: CreateTicketTypeDto, { rejectWithValue }) => {
    try {
      const response = await createTicketTypeAPI(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tao_message'));
    }
  }
);

export const updateTicketType = createAsyncThunk(
  'TicketType/update',
  async (data: UpdateTicketTypeDto, { rejectWithValue }) => {
    try {
      const response = await updateTicketTypeAPI(data.id, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_cap_message'));
    }
  }
);

export const lockTicketType = createAsyncThunk(
  'TicketType/lock',
  async (id: number, { rejectWithValue }) => {
    try {
      await lockTicketTypeAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_khoa_message'));
    }
  }
);

export const unlockTicketType = createAsyncThunk(
  'TicketType/unlock',
  async (id: number, { rejectWithValue }) => {
    try {
      await unlockTicketTypeAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_mo_message'));
    }
  }
);

// Xóa mềm — backend chặn nếu loại vé đang được dùng ở kế hoạch phát hành (trả 409, message chi tiết).
export const deleteTicketType = createAsyncThunk(
  'TicketType/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await deleteTicketTypeAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.data?.message || error?.message || st('co_loi_xay_ra_khi_xoa_message'));
    }
  }
);
